export const CERTIFICATE_TABS = [
  { key: "all", label: "전체" },
  { key: "available", label: "발급 가능" },
  { key: "completed", label: "발급 완료" },
];

export function formatCertificateDate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}.${month}.${day}`;
}

export function getCertificateStatus(certificate) {
  const issued = Boolean(
    certificate?.issued_date || certificate?.is_issued
  );
  return issued ? "completed" : "available";
}

export function getValidityLabel(certificate) {
  const expiry =
    certificate?.valid_until ||
    certificate?.expiry_date ||
    certificate?.validity_end;

  if (!expiry) return "무제한";

  const formatted = formatCertificateDate(expiry);
  return formatted ? `유효기간 : ${formatted}` : "무제한";
}

export function getCompletionDateLabel(certificate) {
  // 교육 수료일은 수강 정보의 completed_at에서 온다(수료증 응답에는 없음).
  // completion_date는 백엔드가 향후 내려줄 경우를 대비한 폴백.
  const completedAt = certificate?.completed_at || certificate?.completion_date;

  // 수료증 발급일보다 교육 수료일이 나중일 수는 없다. 과거 재시청으로
  // completed_at이 발급 이후로 밀린 데이터는 발급일로 보정해 역전을 막는다.
  const issuedAt = certificate?.issued_date;
  let effective = completedAt;
  if (completedAt && issuedAt) {
    const completedTime = new Date(completedAt).getTime();
    const issuedTime = new Date(issuedAt).getTime();
    if (
      !Number.isNaN(completedTime) &&
      !Number.isNaN(issuedTime) &&
      completedTime > issuedTime
    ) {
      effective = issuedAt;
    }
  }

  return formatCertificateDate(effective) || "-";
}

export function getIssuedDateLabel(certificate) {
  if (getCertificateStatus(certificate) === "available") return "-";
  return formatCertificateDate(certificate?.issued_date) || "-";
}

export function filterCertificatesByTab(certificates, tabKey) {
  if (tabKey === "available") {
    return certificates.filter((item) => getCertificateStatus(item) === "available");
  }
  if (tabKey === "completed") {
    return certificates.filter((item) => getCertificateStatus(item) === "completed");
  }
  return certificates;
}
